// @ts-nocheck
import { createSumFromObject, formatSumWithCurrency } from './formatValues';
import {
  EPlacingOrderListItemCol,
  TPlacingOrderListItem
} from '@components/PlacingOrderView/types';
import { ReactNode } from 'react';
import { TLinkedParcel } from '@api/apiClient/returns';

export enum EPlacingOrderViewParcel {
  FBP_NEW_CREATE,
  PICKUP_READY_CREATE,
  PROBLEMATIC_CUSTOMS_RETURN,
  PROBLEMATIC_FIRST_MILE_RETURN,
  RETURN_AWAITING_RESALE,
  RETURN_AWAITING_RETURN,
  UNCLAIMED_AWAITING_RETURN,
  UNCLAIMED_SAVING_RETURN,
  UNCLAIMED_UNPAID_RETURN
}

export enum EPlacingOrderViewParcelType {
  ANY,
  GOOD
}

export type TPlacingOrderViewParcelRest = {
  actionTooltipNoEan?: ReactNode;
  t?: any;
  type?: EPlacingOrderViewParcelType;
  useResaleBlockReason?: boolean;
  variableCurrency?: string | undefined;
}

export const getPlacingOrderView = (items, view: EPlacingOrderViewParcel, rest?: TPlacingOrderViewParcelRest): TPlacingOrderListItem[] => {
  const { actionTooltipNoEan, t, type, useResaleBlockReason, variableCurrency } = rest ?? {};

  return items.map((item) => {
    const linkedParcels: string = (item.linkedParcelCustomerReturns ?? []).map((item: TLinkedParcel) => `<b>${item.returnPostingNumber}</b><br>`).join('');
    const resaleBlockReason = ['RepeatedReturn', 'LastMileOrderNotReceivedInTime'].includes(item.resaleBlockReason)
        ? item.resaleBlockReason
        : 'ResaleBlocked';

    return (
        {
          cols: [
            ...(view === EPlacingOrderViewParcel.FBP_NEW_CREATE ? [
              {
                title: item.ozonSkuId,
                type: EPlacingOrderListItemCol.DEFAULT
              },
              {
                title: item.name,
                type: EPlacingOrderListItemCol.LINK,
                value: item.url
              },
              ...(type === EPlacingOrderViewParcelType.GOOD ? [
                {
                  type: EPlacingOrderListItemCol.DEFAULT,
                  value: formatSumWithCurrency(item.quantity, t('fbpPage.order.itemCount'))
                }
              ] : [])
            ] : []),
            ...(view === EPlacingOrderViewParcel.PICKUP_READY_CREATE ? [
              {
                title: item.trackNumber,
                type: EPlacingOrderListItemCol.TRACKING_NUMBER,
                value: item.externalNumber
              },
              {
                title: item.serviceName,
                type: EPlacingOrderListItemCol.AVATAR
              }
            ] : []),
            ...(view === EPlacingOrderViewParcel.PROBLEMATIC_CUSTOMS_RETURN ? [
              {
                title: item.trackNumber,
                type: EPlacingOrderListItemCol.TRACKING_NUMBER,
                value: item.externalId
              },
              {
                title: item.items[0].name,
                type: EPlacingOrderListItemCol.LINK,
                value: item.items[0].url
              },
              ...(type === EPlacingOrderViewParcelType.ANY ? [
                {
                  title: 'Extra Small',
                  tooltip: t('problematicParcelsPage.orderListItem.state.info_1'),
                  type: EPlacingOrderListItemCol.WARNING
                }
              ] : []),
              ...(type === EPlacingOrderViewParcelType.GOOD ? [
                {
                  title: createSumFromObject(item.declaredValue),
                  type: EPlacingOrderListItemCol.DEFAULT
                }
              ] : [])
            ] : []),
            ...(view === EPlacingOrderViewParcel.PROBLEMATIC_FIRST_MILE_RETURN ? [
              {
                title: item.trackNumber,
                type: EPlacingOrderListItemCol.TRACKING_NUMBER,
                value: item.externalId
              },
              {
                title: item.items[0].name,
                type: EPlacingOrderListItemCol.LINK,
                value: item.items[0].url
              },
              {
                title: createSumFromObject(item.declaredValue),
                type: EPlacingOrderListItemCol.DEFAULT
              }
            ] : []),
            ...(view === EPlacingOrderViewParcel.RETURN_AWAITING_RESALE ? [
              {
                title: item.directStreamExternalId,
                type: EPlacingOrderListItemCol.DEFAULT,
                value: item.trackingNumber
              },
              {
                title: item.title,
                type: EPlacingOrderListItemCol.LINK,
                value: item.url
              },
              ...(type === EPlacingOrderViewParcelType.ANY ? [
                {
                  actionHover: !useResaleBlockReason && ['NoEan'].includes(item.resaleCancelReason) && actionTooltipNoEan,
                  infoOnly: useResaleBlockReason,
                  title: useResaleBlockReason
                      ? formatSumWithCurrency(item.priceRub, '₽')
                      : t(`resaleOrder.states.${item.resaleCancelReason}`),
                  tooltip: useResaleBlockReason
                      ? t(`resaleOrder.tooltip.${resaleBlockReason}`)
                      : ['ExportForbidden', 'NoEan', 'ResellForbidden', 'RelatedPostingReexportVoted'].includes(item.resaleCancelReason)
                          ? ['RelatedPostingReexportVoted'].includes(item.resaleCancelReason) ? t(`resaleOrder.tooltip.${item.resaleCancelReason}`).replace('{{returnPostingNumber}}', linkedParcels) : t(`resaleOrder.tooltip.${item.resaleCancelReason}`)
                          : undefined,
                  type: EPlacingOrderListItemCol.WARNING,
                  value: useResaleBlockReason ? formatSumWithCurrency(item.priceCny, variableCurrency!) : '',
                  withIcon: useResaleBlockReason || ['ExportForbidden', 'NoEan', 'ResellForbidden', 'RelatedPostingReexportVoted'].includes(item.resaleCancelReason)
                }
              ] : []),
              ...(type === EPlacingOrderViewParcelType.GOOD ? [
                {
                  title: formatSumWithCurrency(item.priceRub, '₽'),
                  type: EPlacingOrderListItemCol.DEFAULT,
                  value: formatSumWithCurrency(item.priceCny, variableCurrency!)
                }
              ] : [])
            ] : []),
            ...(view === EPlacingOrderViewParcel.RETURN_AWAITING_RETURN ? [
              {
                title: item.directStreamExternalId,
                type: EPlacingOrderListItemCol.DEFAULT,
                value: item.trackingNumber
              },
              {
                title: item.title,
                type: EPlacingOrderListItemCol.LINK,
                value: item.url
              },
              ...(type === EPlacingOrderViewParcelType.ANY ? [
                {
                  title: t(`returnOrder.states.${item.reexportCancelReason}`),
                  tooltip: item.reexportCancelReason === 'RelatedPostingResellVoted' ? t(`returnOrder.tooltip.${item.reexportCancelReason}`).replace('{{returnPostingNumber}}', linkedParcels) : t(`returnOrder.tooltip.${item.reexportCancelReason}`),
                  type: EPlacingOrderListItemCol.WARNING,
                  withIcon: true
                }
              ] : []),
              ...(type === EPlacingOrderViewParcelType.GOOD ? [
                {
                  title: formatSumWithCurrency(item.priceRub, '₽'),
                  type: EPlacingOrderListItemCol.DEFAULT,
                  value: formatSumWithCurrency(item.priceCny, variableCurrency!)
                }
              ] : [])
            ] : []),
            ...(view === EPlacingOrderViewParcel.UNCLAIMED_AWAITING_RETURN ? [
              {
                title: item.trackNumber,
                type: EPlacingOrderListItemCol.TRACKING_NUMBER,
                value: item.externalId
              },
              {
                title: item.items[0].name,
                type: EPlacingOrderListItemCol.LINK,
                value: item.items[0].url
              },
              ...(type === EPlacingOrderViewParcelType.ANY ? [
                {
                  title: 'Extra Small',
                  tooltip: t('problematicParcelsPage.orderListItem.state.info_1'),
                  type: EPlacingOrderListItemCol.WARNING
                }
              ] : []),
              ...(type === EPlacingOrderViewParcelType.GOOD ? [
                {
                  title: createSumFromObject(item.declaredValue),
                  type: EPlacingOrderListItemCol.DEFAULT
                }
              ] : [])
            ] : []),
            ...(view === EPlacingOrderViewParcel.UNCLAIMED_SAVING_RETURN ? [
              {
                title: item.trackNumber,
                type: EPlacingOrderListItemCol.TRACKING_NUMBER,
                value: item.externalId
              },
              {
                title: item.items[0].name,
                type: EPlacingOrderListItemCol.LINK,
                value: item.items[0].url
              },
              {
                title: createSumFromObject(item.estimatedPrice),
                type: EPlacingOrderListItemCol.DEFAULT
              }
            ] : []),
            ...(view === EPlacingOrderViewParcel.UNCLAIMED_UNPAID_RETURN ? [
              {
                title: item.trackNumber,
                type: EPlacingOrderListItemCol.TRACKING_NUMBER,
                value: item.externalId
              },
              {
                title: item.items[0].name,
                type: EPlacingOrderListItemCol.LINK,
                value: item.items[0].url
              },
              {
                title: createSumFromObject(item.declaredValue),
                type: EPlacingOrderListItemCol.DEFAULT
              }
            ] : [])
          ],
          ...(item.countryCode ? { countryCode: item.countryCode } : {}),
          id: item.id
        }
    );
  });
};
